/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import SandboxJiraPageQuery, {
	type SandboxJiraPageQuery as QueryType,
} from './ui/__generated__/SandboxJiraPageQuery.graphql';

type Queries = {
	pageQueryRef: QueryType;
};

type SandboxJiraPageEntryPointComponent = EntryPointComponent<
	Queries, // AdditionalEntryPointsToLoad
	{}, // ComponentProps,
	{}, // ExtraProps
	{}
>;

export const sandboxJiraPageEntryPoint: EntryPoint<
	SandboxJiraPageEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<SandboxJiraPageEntryPointComponent>(
		/* webpackChunkName: "async-sandbox-jira-page", jiraSpaEntry: "jira-spa-sandboxdemo" */ './ui/SandboxJiraPage.tsx',
	),
	getPreloadProps: ({ tenantContext, context }: EntryPointRouteParams) => {
		return {
			queries: {
				pageQueryRef: {
					parameters: SandboxJiraPageQuery,
					variables: {
						cloudId: tenantContext.cloudId,
						enableDefer: Boolean('defer' in context.query ? context.query.defer === 'true' : true),
					},
					options: {
						fetchPolicy: 'network-only' as const,
					},
				},
			},
		};
	},
});
